<template>
  <div class="column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{$t('societes.masqueBloc.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <b-field :label="$t('societes.masqueBloc.masqueCodeFacture')"
                   class="column is-4">
            <b-input
                  v-model="societe.masqueCodeFacture"
                  @focus="open('masqueCodeFacture')">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc.masqueLibelleProduitUnitairePatrimonial')"
                   class="obligatoire column is-4">
            <b-input v-model="societe.masqueLibelleProduitUnitairePatrimonial"
                     @focus="openPopUpLibelleProduit
                 ('masqueLibelleProduitUnitairePatrimonial')">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc.masqueLibelleProduitEcranNumeriquePatrimonial')"
                   class="obligatoire column is-4">
            <b-input v-model="societe.masqueLibelleProduitEcranNumeriquePatrimonial"
                     @focus="openPopUpLibelleProduit
                 ('masqueLibelleProduitEcranNumeriquePatrimonial')">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc.masqueCodeBail')"
                   class="column is-4">
            <b-input v-model="societe.masqueCodeContrat"
                     @focus="openPopUpCodeBailGenerator = true">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc.masqueLibelleProduitUnitaireNonPatrimonial')"
                   class="column is-4">
            <b-input v-model="societe.masqueLibelleProduitUnitaireNonPatrimonial"
                     @focus="openPopUpLibelleProduit
                 ('masqueLibelleProduitUnitaireNonPatrimonial')">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc' +
           '.masqueLibelleProduitEcranNumeriqueNonPatrimonial')"
                   class="column is-4">
            <b-input v-model="societe.masqueLibelleProduitEcranNumeriqueNonPatrimonial"
                     @focus="openPopUpLibelleProduit
                 ('masqueLibelleProduitEcranNumeriqueNonPatrimonial')">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc' +
           '.masqueCodeEmplacement')"
                   class="column is-4">
            <b-input v-model="societe.masqueCodeEmplacement"
                     @focus="openPopUpCodeEmplacementGenerator = true">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc' +
           '.masqueCodeDispositif')"
                   class="column is-4">
            <b-input v-model="societe.masqueCodeDispositif"
                     @focus="openPopUpCodeDispositifGenerator = true">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc' +
           '.masqueCodeMateriel')"
                   class="column is-4">
            <b-input v-model="societe.masqueCodeMateriel"
                     @focus="openPopUpCodeMaterielGenerator = true">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc' +
           '.masqueCodeFace')"
                   class="column is-4">
            <b-input v-model="societe.masqueCodeFace"
                     @focus="openPopUpCodeFaceGenerator = true">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc' +
           '.masqueCodeParution')" v-if="modulePresseActive"
                   class="column is-4">
            <b-input v-model="societe.masqueCodeParution"
                     @focus="openPopUpCodeParutionGenerator = true">
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
    <b-modal v-model="openPopUpCodeBailGenerator"
             has-modal-card class="modal">
      <pop-up-code-generator-bail :value="societe.masqueCodeContrat"
                                  @updateCodeContratGenerator="societe.masqueCodeContrat = $event">
      </pop-up-code-generator-bail>
    </b-modal>
    <b-modal v-model="openPopUp"
             has-modal-card
             class="modal">
      <pop-up-code-generator
            v-model="societe[keyToUpdate]"
            :label="`societes.masqueBloc.${keyToUpdate}`"
            :text="constantes.MASQUES[keyToUpdate]">
      </pop-up-code-generator>
    </b-modal>
    <b-modal v-model="openPopUpCodeEmplacementGenerator"
             has-modal-card class="modal">
      <pop-up-code-generator-emplacement :value="societe.masqueCodeEmplacement"
                                         @updateCodeEmplacementGenerator="
                                         societe.masqueCodeEmplacement = $event">
      </pop-up-code-generator-emplacement>
    </b-modal>
    <b-modal v-model="openPopUpCodeDispositifGenerator"
             has-modal-card class="modal">
      <pop-up-code-generator-dispositif :value="societe.masqueCodeDispositif"
                                        @updateCodeDispositifGenerator="
                                        societe.masqueCodeDispositif = $event">
      </pop-up-code-generator-dispositif>
    </b-modal>
    <b-modal v-model="openPopUpCodeMaterielGenerator"
             has-modal-card class="modal">
      <pop-up-code-generator-materiel :value="societe.masqueCodeMateriel"
                                      @updateCodeMaterielGenerator="
                                      societe.masqueCodeMateriel = $event">
      </pop-up-code-generator-materiel>
    </b-modal>
    <b-modal v-model="openPopUpCodeFaceGenerator"
             has-modal-card class="modal">
      <pop-up-code-generator-face :value="societe.masqueCodeFace"
                                  @updateCodeFaceGenerator="societe.masqueCodeFace = $event">
      </pop-up-code-generator-face>
    </b-modal>
    <b-modal v-model="openPopUpCodeParutionGenerator"
             has-modal-card class="modal">
      <pop-up-code-generator-parution :value="societe.masqueCodeParution"
                            @updateCodeParutionGenerator="societe.masqueCodeParution = $event">
      </pop-up-code-generator-parution>
    </b-modal>
    <b-modal v-model="openPopUpLibelleProduitGenerator"
             has-modal-card class="modal">
      <pop-up-libelle-generator-produit :value="societe[keyToUpdate]"
                                        :typeLibelle="keyToUpdate"
                                        @updateLibelleGenerator="
                                              societe[keyToUpdate] = $event">
      </pop-up-libelle-generator-produit>
    </b-modal>
  </div>
</template>

<script>

import popUpCodeGeneratorBail
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_codeGeneratorBail';
import popUpCodeGeneratorEmplacement
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_codeGeneratorEmplacement';
import popUpCodeGeneratorDispositif
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_codeGeneratorDispositif';
import popUpCodeGeneratorMateriel
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_codeGeneratorMateriel';
import popUpCodeGeneratorFace
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_codeGeneratorFace';
import popUpLibelleGeneratorProduit
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_libelleGeneratorProduit';
import popUpCodeGeneratorParution
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_codeGeneratorParution';
import popUpCodeGenerator
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_codeGenerator';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import MASQUES from '@/services/parametrage/societes/masques/masqueGenerator';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openPopUpCodeBailGenerator: false,
      openPopUpLibelleProduitGenerator: false,
      openPopUpCodeEmplacementGenerator: false,
      openPopUpCodeDispositifGenerator: false,
      openPopUpCodeMaterielGenerator: false,
      openPopUpCodeFaceGenerator: false,
      openPopUpCodeParutionGenerator: false,
      openPopUp: false,
      keyToUpdate: null,
      constantes: {
        MASQUES,
      },
    };
  },
  components: {
    popUpCodeGeneratorBail,
    popUpLibelleGeneratorProduit,
    popUpCodeGeneratorEmplacement,
    popUpCodeGeneratorDispositif,
    popUpCodeGeneratorMateriel,
    popUpCodeGeneratorFace,
    popUpCodeGeneratorParution,
    popUpCodeGenerator,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    openPopUpLibelleProduit(key) {
      this.keyToUpdate = key;
      this.openPopUpLibelleProduitGenerator = true;
    },
    open(key) {
      this.keyToUpdate = key;
      this.openPopUp = true;
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
